export const blockedShortCodeList = [
  4024,
  4022,
  2337,
  4142,
  4148,
  6055,
  6877,
  4060,
  7570,
];

const blockedShortCodes = new Set(blockedShortCodeList);

export const isBlockedShortCode = (shortCode) =>
  blockedShortCodes.has(Number(shortCode));



// WEBPACK FOOTER //
// ./src/utils/shortCodeStatus.js